import React from 'react';

interface MoreActionsDotsProps extends React.SVGProps<SVGSVGElement> {
    fill?: string;
    className?: string;
}

export const MoreActionsDots = ({ fill = '#252733', className = '' }: MoreActionsDotsProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="13"
            viewBox="0 0 4 13"
            fill="none"
            className={className}
        >
            <path
                d="M3.23828 1.26184C3.23828 1.9522 2.67864 2.51184 1.98828 2.51184C1.29793 2.51184 0.738281 1.9522 0.738281 1.26184C0.738281 0.571485 1.29793 0.0118408 1.98828 0.0118408C2.67864 0.0118408 3.23828 0.571485 3.23828 1.26184Z"
                fill={fill}
            />
            <path
                d="M3.26329 6.01208C3.26329 6.70244 2.70364 7.26208 2.01329 7.26208C1.32293 7.26208 0.763286 6.70244 0.763286 6.01208C0.763286 5.32173 1.32293 4.76208 2.01329 4.76208C2.70364 4.76208 3.26329 5.32173 3.26329 6.01208Z"
                fill={fill}
            />
            <path
                d="M3.23682 10.7617C3.23682 11.452 2.67717 12.0117 1.98682 12.0117C1.29646 12.0117 0.736816 11.452 0.736816 10.7617C0.736816 10.0713 1.29646 9.51166 1.98682 9.51166C2.67717 9.51166 3.23682 10.0713 3.23682 10.7617Z"
                fill={fill}
            />
        </svg>
    );
};
